// src/Models/ticketReopenReasonModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class TicketReopenReasonModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      reopenReasonID: data.reopenReasonId || data.reopenReasonID || 0,
      projectID: data.projectId || data.projectID || 0,
      reasonText: data.reasonText || '',
      isMandatoryFlag: data.isMandatoryFlag !== undefined ? data.isMandatoryFlag : true,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      reopenReasonId: Number(data.reopenReasonID || data.reopenReasonId || 0),
      projectId: Number(data.projectID || data.projectId || 0),
      reasonText: data.reasonText || '',
      isMandatoryFlag: data.isMandatoryFlag === true || data.isMandatoryFlag === 'true' || data.isMandatoryFlag === 1,
    };
  }
}
